"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useEffect, useRef } from "react";
import { cj, loadScript } from "../utils";
function buildTitle(title, tooltip) {
    let markerTitle = "Map pin";
    if (title && tooltip) {
        markerTitle = `Map pin on ${title} showing location of ${tooltip}`;
    } else if (title && !tooltip) {
        markerTitle = `Map pin on ${title}`;
    } else if (!title && tooltip) {
        markerTitle = `Map pin showing location of ${tooltip}`;
    }
    return markerTitle;
}
export const MapWidget = /*#__PURE__*/ React.forwardRef(function MapWidget(_param, ref) {
    var { apiKey = "", mapStyle = "roadmap", zoom = 12, latlng = "51.511214,-0.119824", tooltip = "", title = "", enableScroll = true, enableTouch = true, className = "" } = _param, props = _object_without_properties(_param, [
        "apiKey",
        "mapStyle",
        "zoom",
        "latlng",
        "tooltip",
        "title",
        "enableScroll",
        "enableTouch",
        "className"
    ]);
    const mapRef = useRef(null);
    React.useImperativeHandle(ref, ()=>mapRef.current);
    useEffect(()=>{
        const loadMap = ()=>{
            var _window_google, _window;
            if (!mapRef.current) return;
            if (!((_window = window) === null || _window === void 0 ? void 0 : (_window_google = _window.google) === null || _window_google === void 0 ? void 0 : _window_google.maps)) return;
            const { Map, Marker, InfoWindow } = window.google.maps;
            const coords = latlng.split(",");
            const center = {
                lat: parseFloat(coords[0]),
                lng: parseFloat(coords[1])
            };
            const map = new Map(mapRef.current, {
                zoom,
                center,
                mapTypeId: mapStyle,
                mapTypeControl: false,
                panControl: false,
                streetViewControl: false,
                draggable: enableTouch,
                scrollwheel: enableScroll,
                zoomControl: true
            });
            const marker = new Marker({
                draggable: false,
                position: center,
                title: buildTitle(title, tooltip),
                map
            });
            if (tooltip) {
                new InfoWindow({
                    disableAutoPan: true,
                    content: tooltip,
                    position: center
                }).open({
                    anchor: marker,
                    map
                });
            }
            window.google.maps.event.addListener(marker, "click", function() {
                window.open(`https://maps.google.com/?z=${zoom}&daddr=${latlng}`);
            });
        };
        loadScript(`https://maps.googleapis.com/maps/api/js?v=3.52.5&key=${apiKey}`, {
            cacheRegex: /maps\.googleapis\.com\/maps\/api\/js\?v=3\.52\.5\&key=/gi
        }).then(loadMap);
    }, [
        apiKey,
        mapStyle,
        zoom,
        latlng,
        tooltip,
        title,
        enableScroll,
        enableTouch,
        mapRef
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-widget w-widget-map"),
        role: "region",
        ref: mapRef
    }));
});
